import fetch from 'isomorphic-fetch'
import {isClient} from '@cred/shared/utils'

const loggerURL = '/api/logs-fe',
  logger = {},
  loggerCreator = level => (baseData = {}, config = {}) => async (
    event,
    data = {},
    humanMessage = ''
  ) => {
    const ssr = !isClient(),
      eventData = {
        ...baseData,
        ...data
      },
      preparedLog = JSON.stringify({
        level,
        event,
        eventData,
        humanMessage,
        context: {
          timestamp: new Date(),
          ssr
        }
      })

    if (!ssr) {
      // FE
      // eslint-disable-next-line
      console.log(
        `%c ${humanMessage}`,
        'background: lightblue;',
        event,
        eventData
      )
      try {
        const res = await fetch(`${config.credibleRoot || ''}${loggerURL}`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: preparedLog
        })

        if (res.status !== 200) {
          // eslint-disable-next-line
          console.error('LOGGER ERROR', await res.json())
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error('LOGGER NETWORK ERROR', error)
      }
    } else {
      // BE log to STDOUT
      // eslint-disable-next-line
      console.log(preparedLog)
    }
  },
  createLogger = (baseData, config) => {
    logger.info = loggerCreator('info')(baseData, config)
    logger.error = loggerCreator('error')(baseData, config)
  }

export {createLogger, logger}
